import { Box,Button,Card,CardActions,CardContent,CardMedia,Grid,Typography } from '@mui/material'
import React from 'react';
import { motion } from 'framer-motion';
import my from './Tic-Tac.png';
import weather from './weather1.jpg';
import Todo from './Todo.png'
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const Project = () => {
  return (
    <Box id='project' py={7} className='no-select' sx={{ pt: 18,pl:6,
      '@media (min-width:50px) and (max-width:600px)':{
        pl:3
      }
     }}>
      <motion.div
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: -100 }}
        transition={{ duration: 1.0 }}
      >
        <Typography variant="h3" align="center" sx={{ color: 'white', pb: 4 }} gutterBottom>
          Projects
        </Typography>
      </motion.div>
      <Grid container spacing={4} justifyContent="center">
        {/* Card Item Component */}
        {[
          {
            image: weather,
            title: 'WeatherVue',
            description: ' This Project is Collaborative project and this is done by using Java FullStack.This Project contains the Elements related to weather.Want to Know more 👇.',
            hlink : 'https://github.com/AbhiramVelampudi/WeatherVue',
          },
          {
            image: Todo,
            title: 'Todo Management',
            description: 'It assists to manage your daily tasks by reminding you which task you need to perform. This is done using MERN Stack.Want to Know more 👇.',
            hlink : 'https://github.com/Sriram-Radhey/ProjectTEB',
          },
          {
            image: my,
            title: 'Tic-Tac-Toe',
            description: 'The Project is about designing Tic-Tac-Toe Game.This done using Html, CSS and JavaScript.Want to Know more 👇.',
            hlink :'https://github.com/Sriram-Radhey/Tic-Tac-Toe-game-',
          },
        ].map((project, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Card
              sx={{
                maxWidth: 345,
                backgroundColor: 'black',
                color: 'white',
                border: '1px solid violet',
                borderRadius: '15%',
                height: '350px',
                position: 'relative',
                overflow: 'hidden',
                transition: 'transform 0.3s',
                '&:hover':{
                  border : '3px solid cyan',
                },
              }}
            >
              <CardMedia
                sx={{ height: 140}}
                image={project.image}
                title={project.title}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {project.title}
                </Typography>
                <Typography variant="body2" sx={{
                  '&:hover':{
                    fontSize:16
                  },
                  '@media (min-width:50px) and (max-width:600px)':{
                    '&:hover':{
                    fontSize:14
                  },
                  }
                }}>{project.description}</Typography>
              </CardContent>
              <CardActions
                sx={{
                  position: 'absolute',
                  bottom: 16,
                  left: '50%',
                  opacity: 0, 
                  transform: 'translateX(-50%)',
                  transition: 'opacity 0.3s ease-in-out',
                  zIndex: 1,
                  '&:hover': {
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    opacity: 1,
                    mt: 4,
                  },
                }}
              >
                <Button size="small" href={project.hlink} target="_blank">
                  <OpenInNewIcon />
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Project;